export const SHIFT_MANAGEMENT_DIALOG = 'shiftManagementDialog';
export const SHIFT_REFRESH_DIALOG = 'shiftRefreshDialog';
